import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type UnassignPartnerTierInput = {
  programId: string;
  partnerId: string;
};

// DELETE /api/admin/tiers/programs/:programId/partners/:partnerId
//
// Pessimistic. Removing a partner from the default program clears
// partners.tier / tier_id via the 0038 trigger; non-default removals leave
// partners.tier untouched. Either way, invalidate the partner caches and
// the program's assignments listing so views reflect the change.
export function useUnassignPartnerTier() {
  const queryClient = useQueryClient();
  return useMutation<void, ApiClientError, UnassignPartnerTierInput>({
    mutationFn: ({ programId, partnerId }) =>
      apiFetch<void>(
        `/admin/tiers/programs/${programId}/partners/${partnerId}`,
        { method: "DELETE" },
      ),
    onSuccess: (_data, { programId, partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.detail(partnerId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.list() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tiers.assignmentsForProgram(programId),
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.tiers.program(programId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to remove tier assignment");
    },
  });
}
